"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoalTarget = void 0;
/**
 * Describes the intended objective(s) for a patient, group or organization care, for example, weight loss, restoring an activity of daily living, obtaining herd immunity via immunization, meeting a process improvement objective, etc.
 */
var GoalTarget = /** @class */ (function () {
    function GoalTarget() {
    }
    return GoalTarget;
}());
exports.GoalTarget = GoalTarget;
